/* src/app/views/display/components/display-section/display-menu-section/display-menu-section-header/display-menu-section-header.component.scss */
bs-section-header-button-container {
  display: flex;
}
.edit-dates-times-button {
  padding-bottom: 1.5rem;
}
.is-scheduled-info-icon {
  width: 1.5rem;
  height: 1.5rem;
  padding-bottom: 0.25rem;
}
/*# sourceMappingURL=display-menu-section-header.component.css.map */
